import { Spin, Row, Col, Divider } from 'antd'
import Style from '../allocationadd/allocationadd.module.scss'
import businessHooks from './hooks'
import Uploadimg from './components/uploadLIC/uploadimg'
import Businessinfo from './components/business-modules/BusinessInfo'
import withoput_bussiness_license from '../../assets/img/withoput_bussiness_license.png'

const businessInfo = () => {
  const {
    form,
    loading,
    pictures,
    uploadParams,
    enterpriseLevelState,
    licenceList,
    agreementList,
  } = businessHooks()

  return (
    <div>
      <div className={Style['container']}>
        <Divider style={{ margin: '0px' }} />
        <Row>
          <Col span={6}>
            <div style={{ marginTop: '150px' }}>
              {pictures.length && pictures[0].url ? (
                <Uploadimg
                  dataSource={pictures}
                  params={uploadParams}
                  disable={false}
                  disableUpload
                />
              ) : (
                <img
                  style={{ marginLeft: '20px' }}
                  src={withoput_bussiness_license}
                />
              )}
            </div>
          </Col>
          <Col span={18}>
            <div className={Style['box-form']}>
              <Spin spinning={loading}>
                <Businessinfo
                  form={form}
                  enterpriseLevelState={enterpriseLevelState}
                  licenceList={licenceList}
                  agreementList={agreementList}
                ></Businessinfo>
              </Spin>
            </div>
          </Col>
        </Row>
      </div>
    </div>
  )
}

export default businessInfo
import { Spin, Row, Col, Divider } from 'antd'
import Style from '../allocationadd/allocationadd.module.scss'
import businessHooks from './hooks'
import Uploadimg from './components/uploadLIC/uploadimg'
import Businessinfo from './components/business-modules/BusinessInfo'
import withoput_bussiness_license from '../../assets/img/withoput_bussiness_license.png'

const businessInfo = () => {
  const {
    form,
    loading,
    pictures,
    uploadParams,
    enterpriseLevelState,
    licenceList,
    agreementList,
  } = businessHooks()

  return (
    <div>
      <div className={Style['container']}>
        <Divider style={{ margin: '0px' }} />
        <Row>
          <Col span={6}>
            <div style={{ marginTop: '150px' }}>
              {pictures.length && pictures[0].url ? (
                <Uploadimg
                  dataSource={pictures}
                  params={uploadParams}
                  disable={false}
                  disableUpload
                />
              ) : (
                <img
                  style={{ marginLeft: '20px' }}
                  src={withoput_bussiness_license}
                />
              )}
            </div>
          </Col>
          <Col span={18}>
            <div className={Style['box-form']}>
              <Spin spinning={loading}>
                <Businessinfo
                  form={form}
                  enterpriseLevelState={enterpriseLevelState}
                  licenceList={licenceList}
                  agreementList={agreementList}
                ></Businessinfo>
              </Spin>
            </div>
          </Col>
        </Row>
      </div>
    </div>
  )
}

export default businessInfo
